// extracted by mini-css-extract-plugin
export var cardIcon = "_a3-4";
export var checkboxCard = "_a3-0";
export var checkboxCardSelected = "_a3-1";
export var disabled = "_a3-2";
export var outerBorder = "_a3-3";
export var spacerMedium = "_a3-7";
export var spacerSmall = "_a3-6";
export var spacerXsmall = "_a3-5";